'use strict';

import * as Onyx from '../lib/onyx.min.js';

export default class MatterJSEntity extends Onyx.Entity {
    constructor(matterEngine = null, position = [0,0], scale = [1,1,1], rotation = 0, body){
        super();

        this.matterEngine = matterEngine;

        this.waitForSleep = true; // Wait for sleep before moving on to next round
        this.canPlaySound = true; // So we don't get rapid fire SFX
        
        this.transform.translateTo(position[0], position[1], position[2]);
        this.transform.scale(scale[0], scale[1], scale[2]);

        if(body && matterEngine){
            this.physicsEnabled = true;
            this.body = body;
            this.body.parentEntity = this;
            this.body.prevVelocity = {x: 0, y: 0};

            Matter.Body.rotate(this.body, rotation);
            Matter.World.add(this.matterEngine.world, [this.body]);
        }
    }
 
    update(...args){
        super.update(...args);

        if(this.parentScene && this.physicsEnabled && this.parentScene.physicsEnabled){
            this.transform.translateTo(this.body.position.x, -this.body.position.y);
            this.transform.rotateToZ(-this.body.angle);

            this.body.prevVelocity = {x: this.body.velocity.x, y: this.body.velocity.y};
        }
    }

    onDestroy(...args){
        super.onDestroy(...args);

        if(this.body) Matter.World.remove(this.matterEngine.world, [this.body]);
    }
}